import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-popular-collections',
  templateUrl: './popular-collections.component.html',
  styleUrls: ['./popular-collections.component.scss']
})
export class PopularCollectionsComponent implements OnInit {
  slidesData: any = [];
  popularData:any = [];

  constructor(private dataService: DataService,) { }

  async ngOnInit() {
    (await this.dataService.getPopularBannerService()).subscribe((singleservice) => {
      this.slidesData = [];
      this.slidesData = singleservice;
      //console.log(this.slidesData)
    });
    
    (await this.dataService.getCollectionService()).subscribe(
      (singleservice) => {
        this.popularData = [];

        this.popularData = singleservice.filter((data)=>{
          return data["isFeatured"]
        })

        //console.log(this.popularData);
      }
    );
  }

}
